import { z } from "zod";

export const PROFILE_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const PROFILE_TITLE_MAX_LENGTH = 120;
export const UserProfileSchema = z.object({
  image: z.string().nullable(),
  title: z.string().nullable(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;

export const UpdateUserProfileSchema = z
  .object({
    title: z.string().trim().max(PROFILE_TITLE_MAX_LENGTH).nullable().optional(),
    image: z
      .object({
        base64: z
          .string()
          .min(1)
          .max(Math.ceil(PROFILE_IMAGE_MAX_BYTES / 3) * 4),
      })
      .strict()
      .nullable()
      .optional(),
  })
  .strict()
  .refine((input) => input.title !== undefined || input.image !== undefined, {
    message: "Nothing to update",
  });
export type UpdateUserProfile = z.infer<typeof UpdateUserProfileSchema>;
